import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { translateRestriction } from './propertyCzUtils';
import PropertyCzNotes from './propertyCzNotes';
import { searchActions, cuzkExpandType } from '../../../store/searchStore';

import './propertyCz.scss';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class PropertyCzFlat extends React.Component {
    state = {
        expanded: true
    };

    static propTypes = {
        data: PropTypes.object.isRequired
    };

    render() {
        const data = this.props.data;
        return (
            <>
                <tr>
                    <td>
                        <span onClick={() => this.expandRow(data)} className="link-internal">
                            <Translate id='Report.Detail' />
                        </span>
                    </td>
                    <td>{data.spaceType}</td>
                    <td>{data.parcelId}/{data.unitId}</td>
                    <td>
                        <span>{translateRestriction(data.ownershipRestriction, this.props.translate)}</span>
                        <span className="cuzk-seal">{data.hasSeal ? <Translate id="PropertyCz.Report.OD.Seal" /> : null}</span>
                    </td>
                </tr>
                {this.state.expanded && this.renderDetail(data)}
            </>
        )
    }

    renderDetail = (data) => {
        return (
            <tr>
                <td colSpan={4}>
                    <OldStyleTableWithHistory
                        colWidths={["25%","25%","25%","25%"]} noMargin
                        actualData={[1,2]} fixed classNames='old-style-bordered'
                        actualRow={p => <>{p===1 && <tr>
                            <th><Translate id="PropertyCz.Report.OD.Usage" /></th>
                            <td>{data.usage}</td>
                            <th><Translate id="PropertyCz.Report.OD.ProtectionType" /></th>
                            <td style={{wordBreak:'break-word'}}>{data.protection}</td>
                        </tr>}{p===2 && <tr>
                            <td colSpan={4}>
                                <PropertyCzNotes notes={data.ownershipRestrictions} restrictions />
                                <PropertyCzNotes notes={data.notes} />
                            </td>
                        </tr>}</>} />
                </td>
            </tr>
        )
    }

    expandRow = (data) => {
        this.setState({ expanded: !this.state.expanded }, () => this.props.cuzkExpand(cuzkExpandType.flats, null, this.props.telId, data.id, this.state.expanded ))
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search.cuzk } }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(PropertyCzFlat)));